import Vue from "vue";
import VueRouter, { RawLocation, RouteConfig, Route } from "vue-router";
import Home from "../views/Home.vue";
import { store } from "../main";

Vue.use(VueRouter);

// to prevent console errors if current and new paths are the same
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation) {
  // @ts-ignore
  return originalPush.call(this, location).catch(() => {});
};

const setTheming = (to: Route): void => {
  let isThemed = to.matched.some((record) => record.meta.theming);
  store.commit("setTheming", isThemed);
};
export const commonRoutes: Array<RouteConfig> = [
  {
    path: "/travels",
    name: "Travels",
    meta: { theming: true },
    component: () => import("../views/Travels.vue"),
  },
  {
    path: "/services",
    name: "Services",
    component: () => import("../views/Services.vue"),
  },
  //  {
  //   path: '/process',
  //   name: 'Process',
  //   component: () => import('../views/outside/Process.vue')
  // },
  {
    path: "/team-content",
    name: "Team-content",
    component: () => import("../views/outside/Team.vue"),
  },
  // {
  //   path: '/faq',
  //   name: 'Faq',
  //   component: () => import('../views/outside/Faq.vue')
  // }
];

const errorRoutes: Array<RouteConfig> = [
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/errors/NotFound.vue"),
  },
];

const checkoutRoutes: Array<RouteConfig> = [
  {
    path: "/orders/:token/checkout",
    name: "Checkout",
    component: () => import("../views/order/Checkout.vue"),
  },
];

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  ...commonRoutes,
  {
    path: "/policy",
    name: "Policy",
    component: () => import("../views/outside/Policy.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/outside/About.vue"),
  },
  {
    path: "/travels/:id",
    name: "Travel",
    component: () => import("../views/Travel.vue"),
  },
  {
    path: "/orders/:token",
    name: "Order",
    component: () => import("../views/order/Order.vue"),
  },
  {
    path: "/orders/:token",
    name: "Order",
    component: () => import("../views/order/Order.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/outside/News.vue"),
  },
  {
    path: "/news/:id",
    name: "NewsId",
    component: () => import("../views/NewsId.vue"),
  },
  // {
  //   path: '/requirements',
  //   name: 'Requirements',
  //   component: () => import('../views/outside/Requirements.vue')
  // },
  ...checkoutRoutes,
  ...errorRoutes,
];

export const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach((to, _, next) => {
  store.commit("setLoading", true);
  next();
});

router.afterEach((to) => {
  store.commit("setLoading", false);
  setTheming(to);
  if (!to.hash) {
    window.scrollTo({ top: 0 });
  }
});
